export interface AdminConfig {
  rootAdmin: {
    email: string;
    name: string;
    role: 'super_admin';
  };
  /** "development" | "staging" | "production" — set by Vite at build time via --mode */
  environment: string;
  requireAuth: boolean;
  /** Cloud Function base URL — baked in from VITE_API_BASE_URL at build time */
  apiBaseUrl: string;
  /** CF Worker base URL — baked in from VITE_WORKER_URL at build time */
  workerUrl: string;
}

const ROOT_ADMIN = {
  email: 'admin@aegis-ai.com',
  name: 'Aegis AI Root Admin',
  role: 'super_admin' as const,
};

const mode = import.meta.env.MODE; // "development" | "staging" | "production"

export const adminConfig: AdminConfig = {
  rootAdmin: ROOT_ADMIN,
  environment: mode,
  requireAuth: mode !== 'development',
  // VITE_API_BASE_URL is set in .env.development / .env.production / .env.staging
  // and baked into the bundle at build time — no runtime hostname sniffing.
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL as string,
  workerUrl: import.meta.env.VITE_WORKER_URL as string,
};

export const isLocalEnvironment = () => adminConfig.environment === 'development';
export const requiresAuthentication = () => adminConfig.requireAuth; 